import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20dark%20lighting%2C%20powerful%20spotlights%20illuminating%20green%20field%2C%20abstract%20sports%20energy%20background%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20professional%20sports%20photography%2C%20clean%20and%20dramatic%20composition%2C%20no%20text%2C%20atmospheric%20lighting%2C%20wide%20angle%20stadium%20view&width=1920&height=1080&seq=kaiyun-hero-bg&orientation=landscape"
        alt="kaiyun体育 - 全球体育赛事平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-background-50/90 text-sm font-medium">全球顶级赛事 · 实时追踪</span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-4 leading-tight tracking-wide">
            汇聚全球顶级赛事
          </h1>
          <p className="text-background-50/80 text-base md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
            随时随地畅享体育精彩 — 覆盖足球、篮球、网球、电竞等30+体育项目<br className="hidden md:block" />
            实时比分、专业分析、高清直播，一站式体育服务平台
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
            <button
              onClick={() => {
                navigate('/category/football');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-base"
            >
              立即体验
            </button>
            <button
              onClick={() => {
                navigate('/about');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="w-full sm:w-auto px-8 py-3.5 border border-background-50/30 text-background-50 font-medium rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap text-base"
            >
              了解更多
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}